var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavDashboard = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.8,9.3l-8.1-9c-0.3-0.4-1-0.4-1.3,0l-8.1,9C0.1,9.4,0,9.6,0,9.8c0,0.2,0,0.3,0.1,0.5 c0.1,0.3,0.5,0.5,0.8,0.5h1.8v6.3c0,0.2,0.1,0.5,0.3,0.6C3.1,17.9,3.4,18,3.6,18h2.7c0.2,0,0.5-0.1,0.6-0.3 c0.2-0.2,0.3-0.4,0.3-0.6v-3.6h3.6v3.6c0,0.2,0.1,0.5,0.3,0.6c0.2,0.2,0.4,0.3,0.6,0.3h2.7c0.2,0,0.5-0.1,0.6-0.3 c0.2-0.2,0.3-0.4,0.3-0.6v-6.3h1.8c0.2,0,0.3,0,0.5-0.1s0.3-0.2,0.3-0.4S18,9.9,18,9.8C18,9.6,17.9,9.4,17.8,9.3z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    x1: 0,
    y1: -54,
    x2: 0,
    y2: -18
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    x1: -54,
    y1: 0,
    x2: -18,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    x1: -54,
    y1: 18,
    x2: -18,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    x1: 0,
    y1: 72,
    x2: 0,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    x1: 18,
    y1: -54,
    x2: 18,
    y2: -18
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    x1: 72,
    y1: 0,
    x2: 36,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    x1: 72,
    y1: 18,
    x2: 36,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.3,
    x1: 18,
    y1: 72,
    x2: 18,
    y2: 36
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavDashboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nav-dashboard.183667e1555e5d95d8035b5088fbc8cf.svg";